export enum SortOrder {
    Name,
    Status,
    Type,
    AreaCount,
    TotalAreaSize,
    LatestChange,
}

// Note. We haven't renamed the grass quality enum since that will affect DB.
// The grass quality types in Husqvarnamap are now:
// Max 72 (Regular)
// Standard 48 (Pro)
// Sport 24 (ProSport)
export enum CuttingQuality {
    Regular = "Regular",
    Pro = "Pro",
    ProSport = "ProSport"
}

export enum FuelType {
    Diesel = "Diesel",
    Petrol = "Petrol"
}

export enum ProjectStatus {
    InProgress = "InProgress",
    Completed = "Completed",
    Empty = "Empty"
}

export enum ProjectType {
    Other = "Other",
    FacilityManagement = "FacilityManagement",
    Golf = "Golf",
    HospitalityResort = "HospitalityResort",
    LandscapeContractor = "LandscapeContractor",
    MunicipalityPublicSite = "MunicipalityPublicSite",
    SchoolUniversity = "SchoolUniversity",
    Sport = "Sport",
}

export enum Month {
    January = "January",
    February = "February",
    March = "March",
    April = "April",
    May = "May",
    June = "June",
    July = "July",
    August = "August",
    September = "September",
    October = "October",
    November = "November",
    December = "December"
}

export enum ProductType {
    Mower = "Mower",
    EPOSReferenceStation = "EPOSReferenceStation",
    Epos4gReferenceStation = "Epos4gReferenceStation"
}

export enum AmountUnit {
    Currency = "Currency",
    Percent = "Percent",
}

export enum UnitSystem {
    Metric = "Metric",
    Imperial = "Imperial",
}

export enum FinancingOption {
    DirectPayment = "DirectPayment",
    Leasing = "Leasing",
}

export enum LeasingPeriod {
    Months36 = "Months36",
    Months60 = "Months60",
}
